import { useMutation } from "@tanstack/react-query";
import authService from "..";
import { SignInPayload } from "../type";

function useLoginByPassword() {
  return useMutation({
    mutationFn: (command: SignInPayload) => {
      return authService.loginByPassword(command);
    },
  });
}

export default useLoginByPassword;
